import React, { useEffect } from 'react';
import CotizacionTable from './tables/CotizacionTable';

const Cotizacion: React.FC = () => {
  useEffect(() => {
    console.log('Componente Cotizacion montado.');
  }, []);
  return (
    <div className="container mx-auto px-4 py-8">
      <CotizacionTable />
    </div>
  );
};

export default Cotizacion; 